import { Component, inject, effect, signal, Input, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TypographyComponent, MonacoComponent } from '@hyperkit';
import { HuntContextService } from '../../../../../services/hunt-context.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { debounceTime } from 'rxjs/operators';
import { EditorComponent } from '../../../../../details/components/hyperkit';

@Component({
  selector: 'query-selected-overview-tab',
  standalone: true,
  imports: [CommonModule, TypographyComponent, EditorComponent, MonacoComponent],
  templateUrl: './overview-tab.component.html',
  styleUrl: './overview-tab.component.scss',
})
export class OverviewTabComponent implements OnDestroy, OnInit {
  @Input() queryInstanceKey!: string;

  readonly hunt = inject(HuntContextService);

  readonly selectedQuery = this.hunt.queryLogic.selectedQuery;

  readonly rawQuery = signal(''); 
  readonly formattedNotes = signal(''); 

  constructor() {
    // Sync when query changes
    effect(() => {
      const query = this.selectedQuery();
      if (query) {
        console.log('[selectedQuery] updated:', query);
        this.rawQuery.set(query.query ?? '');
        this.formattedNotes.set(query.notes ?? '');
      }
    });

    // ✅ Auto-save notes
    const notes$ = toObservable(this.formattedNotes);
    effect(() => {
      notes$
        .pipe(debounceTime(500))
        .subscribe((newNotes) => {
          this.saveNotes(newNotes);
        });
    });

    // ✅ Auto-save raw query
    const rawQuery$ = toObservable(this.rawQuery);
    effect(() => {
      rawQuery$
        .pipe(debounceTime(500))
        .subscribe((newQuery) => {
          this.saveQuery(newQuery);
        });
    });
  }

  ngOnInit() {
    console.log('[OverviewTabComponent] mounted with key:', this.queryInstanceKey);
  }

  ngOnDestroy() {
    console.log('🔥 OverviewTabComponent destroyed');
  }

  saveNotes(newNotes: string) {
    this.hunt.editor.updateSelectedQueryContent({ notes: newNotes }, this.hunt.queryLogic);
  }

  saveQuery(newQuery: string) {
    this.hunt.editor.updateSelectedQueryContent({ query: newQuery }, this.hunt.queryLogic);
  }
}
